function initialFlowModel() {
  return {
    language: localStorage.getItem('language') || 'ru',
  };
}

export default initialFlowModel;
